export const NavLinksList = [
    {
        name: 'Home',
        path: '/home',
        icon: 'fa fa-home'
    },
    {
        name: 'About Me',
        path: '/about-me',
        icon: 'fa fa-info'
    },
    {
        name: 'Experience',
        path: '/experience',
        icon: 'fa fa-briefcase'
    },
    {
        name: 'Blogs',
        path: 'https://blogs.rajivnayanc.com',
        icon: 'fa fa-blog',
        external: true
    },
    {
        name: 'Education',
        path: '/education',
        icon: 'fa fa-book'
    },
    {
        name: 'Projects',
        path: '/projects',
        icon: 'fa fa-tasks'
    },
    {
        name: 'Publications',
        path: '/publications',
        icon: 'fa fa-file'
    },
];